import React from "react";
import ReactDOMServer from "react-dom/server";

import {
  isLumberCommodity,
  isPanelsCommodity,
} from "../../../../utils/loadTypeUtils";

import { OutboundPOSBody } from "./OutboundPOSBody";
import { LumberPOSBody } from "./LumberPOSBody";

const getPOSBody = (commodity) => {
  if (isLumberCommodity(commodity) || isPanelsCommodity(commodity)) {
    return LumberPOSBody;
  }
  return OutboundPOSBody;
};

export const getOutboundPOSBody = (record, enclosePhotos, encloseDocs) => {
  const POSComponent = getPOSBody(record.reloadYardCommodityId);

  return ReactDOMServer.renderToString(
    <POSComponent
      record={record}
      enclosePhotos={enclosePhotos}
      encloseDocs={encloseDocs}
    />
  );
};
